export default {
  sm: `
  After disaster recovery, we act quickly to follow up with systems to restore existing services. We also strengthen our ability to respond in the real world by gaining experience in disaster recovery through ongoing mock-ups and drills.
  `,
};  